import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          今日热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">实时追踪娱乐圈最热争议标签</p>
        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((item) => (
            <a
              key={item.tag}
              href={item.href}
              className="group flex items-center gap-2 px-5 py-2.5 bg-background-50 border border-background-200 rounded-full hover:border-accent-300 hover:bg-accent-50 transition-all cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-accent-700 whitespace-nowrap">
                #{item.tag}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}